import { useEffect } from "react";

const headerOffset = 130;

export const scrollToElement = (elementId: string, timeout = 0) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  const yPosition = element.offsetTop - headerOffset;
  setTimeout(() => {
    window.scrollTo({ top: yPosition, behavior: "smooth" });
  }, timeout);
};

const useScrollToElement = (elementId: string, timeout = 0) => {
  useEffect(() => {
    if (!elementId) return;
    scrollToElement(elementId, timeout);
  }, [elementId, timeout]);
};

export default useScrollToElement;
